import React from 'react';
import PropTypes from 'prop-types';
import Input from '../form-elements/input';
import Messages from '../../constants/Messages';

const Checkbox = (props) => {
    const {
        value = Messages.CART.EVENT_CASH_OPTION.VALUE,
        onCheck, 
        checked = false
    } = props;

    return (
            <Input 
                type = "checkbox"
                value = {value}
                onChange = {onCheck}
                className = "h-4 w-4 accent-[#be133c] cursor-pointer"
                checked = {checked}
            />
    )
}

Checkbox.propTypes = {
    value : PropTypes.string,
    onCheck : PropTypes.func,
    checked : PropTypes.bool
};

export default Checkbox;